import {
	FETCH_INTERVIEW_ROUNDS_SUCCESS,
	FETCH_INTERVIEW_ROUND_BY_ID_SUCCESS,
	INTERVIEW_ROUNDS_REQUEST_LOADING,
	INTERVIEW_ROUNDS_REQUEST_ERRORS,
	INTERVIEW_ROUND_GENERATE_LOADING,
	INTERVIEW_ROUND_EVALUATE_LOADING
} from "api/menu/hr/interviews/actions";

const initialState = {
	loading: false,
	generateLoading: false,
	evaluateLoading: false,
	errors: [],
	rounds: [],
	singleRound: {}
};

export default function(state = initialState, action) {
	switch (action.type) {
		case INTERVIEW_ROUNDS_REQUEST_LOADING:
			return { ...state, loading: true };
		case INTERVIEW_ROUNDS_REQUEST_ERRORS:
			return { ...state, loading: false, errors: action.payload };
		case FETCH_INTERVIEW_ROUNDS_SUCCESS:
			return { ...state, loading: false, rounds: action.payload };
		case FETCH_INTERVIEW_ROUND_BY_ID_SUCCESS:
			return { ...state, loading: false, singleRound: action.payload };
		case INTERVIEW_ROUND_GENERATE_LOADING:
			return { ...state, generateLoading: !!action.payload };
		case INTERVIEW_ROUND_EVALUATE_LOADING:
			return { ...state, evaluateLoading: !!action.payload };
		default:
			return state;
	}
}
